<template>
  <div v-if="showDetails">
    <div class="row">
      <b-modal
        centered
        ref="dialogWait"
        no-close-on-backdrop
        no-close-on-esc
        size="sm"
        hide-header
        hide-footer
      >
        <div class="center-xs">
          <spinner />
        </div>
        <div class="center-xs pt-3">
          {{ currentLoadingMessage }}
        </div>
      </b-modal>
    </div>

    <div id="details">
      <header id="header" class="row">
        <div :class="`col-xs-12 monit-item ${bgStatus}`">
          <h5 class="mb-0 pt-1">{{ Object.keys(item).length && item.NAME }}</h5>
          <div class="update">
            <clock-icon title="" /> {{ updated }}
            <span v-if="editor">por {{ editor }}</span>
          </div>
        </div>
        <div
          :class="`col-xs-6 monit-tabs ${active == 'info' ? 'active' : ''}`"
          @click="selectDetails(0)"
        >
          Informações
        </div>
        <div
          v-if="item.MANAGEMENT"
          :class="`col-xs-6 monit-tabs ${active == 'charts' ? 'active' : ''}`"
          @click="selectDetails(1)"
        >
          Manejo
        </div>
      </header>

      <div v-if="item.MANAGEMENT" class="column details-area px-2">
        <div class="col-xs-12 content" v-if="active == 'info'">
          <span class="border-0"> Atuador: {{ item.ACTUATOR_NAME }} </span>

          <span class="my-2" />

          <div class="percent-box overflow-hidden">
            <div
              :class="`percent-progress ${bgStatus}`"
              :style="`width: ${calcPercentageRounded(
                item.MANAGEMENT.FINAL_STORAGE,
                item.MANAGEMENT.MAX_STORAGE
              )}%;min-width: 1%;`"
            />

            <span class="percent-text"> Água disponível final </span>
            <span class="percent-ping"> </span>
            <div class="percent-value">
              {{
                calcPercentageRounded(
                  item.MANAGEMENT.FINAL_STORAGE,
                  item.MANAGEMENT.MAX_STORAGE
                )
              }}<span class="percent-unit">%</span>
            </div>
          </div>

          <div class="d-flex my-3 justify-content-around">
            <div class="d-flex flex-column align-items-center">
              <div class="ad-percentage-title">AD inicial:</div>
              <div>
                {{ item.MANAGEMENT.INITIAL_STORAGE }}mm ({{
                  calcPercentageRounded(
                    item.MANAGEMENT.INITIAL_STORAGE,
                    item.MANAGEMENT.MAX_STORAGE
                  )
                }}%)
              </div>
            </div>

            <div class="d-flex flex-column align-items-center">
              <div class="ad-percentage-title">AD final:</div>
              <div>
                {{ item.MANAGEMENT.FINAL_STORAGE }}mm ({{
                  calcPercentageRounded(
                    item.MANAGEMENT.FINAL_STORAGE,
                    item.MANAGEMENT.MAX_STORAGE
                  )
                }}%)
              </div>
            </div>
          </div>

          <div v-if="!item.STATUS.includes('Colhido')" class="mt-5">
            <div class="accordion mb-2" role="tablist">
              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-aa
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Resumo de Atividade do Setor</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-aa"
                  accordion="my-accordion-a"
                  role="tabpanel"
                  visible
                >
                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Para Hoje:
                      </strong>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        :tbody-tr-class="bladeTableClass"
                        fixed
                        outlined
                        :items="scheduleItems"
                        :fields="scheduleFields"
                      >
                      </b-table>
                    </div>
                  </b-card-text>

                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Histórico Até Ontem:
                      </strong>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        fixed
                        outlined
                        :items="baseHistoryItems"
                        :fields="baseHistoryFields"
                      >
                      </b-table>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-d
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Agendas Detalhadas</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>

                <b-collapse
                  id="accordion-d"
                  accordion="my-accordion-a"
                  role="tabpanel"
                >
                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Agenda Sugerida:
                      </strong>
                      <b-table
                        striped
                        table-class="table-agn mb-0"
                        :tbody-tr-class="bladeTableClass"
                        fixed
                        outlined
                        :items="suggestionScheduleInfo"
                        :fields="scheduleFields"
                      >
                      </b-table>
                    </div>
                  </b-card-text>

                  <b-card-text class="p-0">
                    <div class="d-flex flex-column">
                      <strong class="py-3 pl-2 pr-3 border-1 border-black">
                        Agendas Ativas:
                      </strong>
                      <b-table
                        v-if="!loadingDetails"
                        striped
                        table-class="table-agn mb-0"
                        :tbody-tr-class="bladeTableClass"
                        fixed
                        outlined
                        :items="runningSchedulesInfo"
                        :fields="scheduleFields"
                      >
                      </b-table>
                      <div v-else class="p-3">...</div>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-c
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Dados Base do Setor</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-c"
                  accordion="my-accordion-a"
                  role="tabpanel"
                >
                  <b-card-text class="p-3">
                    <div>
                      <div>
                        <strong> Último balanço calculado: </strong>
                        {{ managementDate }}
                      </div>
                      <div>
                        <strong> ID do Setor: </strong> {{ item.ID_SECTOR }}
                      </div>
                      <div>
                        <strong> Cultivar: </strong>
                        {{ item.FARM.NAME || "indefinido" }}
                      </div>

                      <div>
                        <strong> Solo: </strong>
                        {{ item.SOIL.NAME || "Indefinido" }}
                      </div>

                      <div>
                        <strong> Data Inicial de Manejo: </strong>
                        {{
                          formatDate(
                            item.VOLUME_DATE
                              ? item.VOLUME_DATE
                              : item.PLANTING_DATE
                          )
                        }}
                      </div>

                      <div>
                        <strong> Data de Plantio: </strong>
                        {{
                          item.PLANTING_DATE
                            ? formatDate(item.PLANTING_DATE)
                            : "Indefinida"
                        }}
                      </div>

                      <div>
                        <strong> Data de Colheita: </strong>
                        {{
                          item.DATE_CROP
                            ? formatDate(item.DATE_CROP)
                            : "Indefinida"
                        }}
                      </div>

                      <div>
                        <strong> NDC: </strong>
                        {{ item.NDC }}
                      </div>

                      <div>
                        <strong> DAP: </strong>
                        {{ item.MANAGEMENT.ID_DAP }}
                      </div>

                      <div>
                        <strong> KC: </strong>
                        {{ item.MANAGEMENT.KC }}
                      </div>

                      <div>
                        <strong> Projeção de Rama (m): </strong>
                        {{ item.MANAGEMENT.BRANCH }}
                      </div>

                      <div>
                        <strong> Profundidade de Raiz (cm): </strong>
                        {{ item.MANAGEMENT.DEPTH_ROOT }}
                      </div>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-2">
                <div header-tag="div" role="tab">
                  <b-button
                    block
                    v-b-toggle.accordion-ca
                    variant="3v3"
                    class="w-100 d-flex align-items-center justify-content-between"
                  >
                    <div>Informativos</div>
                    <div class="arrow-suffix" />
                  </b-button>
                </div>
                <b-collapse
                  id="accordion-ca"
                  accordion="my-accordion-a"
                  role="tabpanel"
                >
                  <b-card-text class="p-3">
                    <div>
                      <div v-if="!loadingDetails">
                        <div v-if="!sectorInfos.EXCESS_ACCUMULATED">
                          Sem excedente acumulado
                        </div>
                        <div v-if="!sectorInfos.VOLUME_ACCUMULATED">
                          Sem volume acumulado
                        </div>
                        <div v-if="!item.MANAGEMENT.EXCESS">
                          Sem previsão de excedente
                        </div>
                      </div>

                      <div
                        v-if="sectorInfos.EXCESS_ACCUMULATED || loadingDetails"
                      >
                        <strong> Excedente acumulado: </strong>
                        <span v-if="loadingDetails"> ... </span>
                        <span v-else>
                          {{
                            sectorInfos.EXCESS_ACCUMULATED &&
                            sectorInfos.EXCESS_ACCUMULATED.toFixed(2)
                          }}mm
                        </span>
                      </div>

                      <div
                        v-if="sectorInfos.VOLUME_ACCUMULATED || loadingDetails"
                      >
                        <strong> Volume acumulado: </strong>
                        <span v-if="loadingDetails"> ... </span>
                        <span v-else>
                          {{
                            sectorInfos.VOLUME_ACCUMULATED &&
                            sectorInfos.VOLUME_ACCUMULATED.toFixed(2)
                          }}m³
                        </span>
                      </div>

                      <div v-if="item.MANAGEMENT.EXCESS">
                        <strong> Previsão de excedente: </strong>
                        <span v-if="loadingDetails"> ... </span>
                        <span v-else>
                          {{
                            item.MANAGEMENT.EXCESS &&
                            item.MANAGEMENT.EXCESS.toFixed(2)
                          }}mm
                        </span>
                      </div>

                      <span v-if="item.NOTE" class="jump-line">
                        <br />
                        <strong> Observações: </strong>
                        {{ item.NOTE }}
                        <br />
                      </span>
                    </div>
                  </b-card-text>
                </b-collapse>
              </b-card>
            </div>
          </div>

          <b-collapse
            id="collapse-4"
            class="mb-1"
            v-model="visible"
            v-if="'INPUTS' in item && item.INPUTS.length"
          >
            <p class="warning-command mt-3">
              <alert-icon /> Utilize os comandos do sensor com cuidado.
            </p>

            <div class="mb-4 mt-4">
              <div
                v-for="button in item.BUTTONS"
                :key="button.name"
                class="buttons"
              >
                <b-button
                  variant="3v3"
                  block
                  @click="buttons(button.COMMAND)"
                  size="sm"
                >
                  {{ button.NAME }}
                </b-button>
              </div>
            </div>
            <!-- COMMANDS -->
          </b-collapse>
        </div>
        <div class="h-100" v-else>
          <div v-if="loadingDetails" class="col-xs-12 center-xs mt-2">
            <spinner /> Aguarde...
          </div>
          <div v-else-if="managementHistory.length">
            <div class="filter-section-box d-flex align-items-center flex-wrap mb-3" style="gap: 0.5rem 1rem">
              <span class="filter-section-label text-nowrap">Filtrar histórico de manejo:</span>
              <div class="d-flex align-items-center flex-grow-1" style="gap: 0.25rem; min-width: 160px">
                <small class="text-muted text-nowrap">Início</small>
                <b-form-input
                  v-model="filterStartDate"
                  type="date"
                  size="sm"
                  class="flex-grow-1"
                  :min="historyMinDate"
                  :max="filterEndDate || historyMaxDate"
                  style="min-width: 130px"
                />
              </div>
              <div class="d-flex align-items-center flex-grow-1" style="gap: 0.25rem; min-width: 160px">
                <small class="text-muted text-nowrap">Fim</small>
                <b-form-input
                  v-model="filterEndDate"
                  type="date"
                  size="sm"
                  class="flex-grow-1"
                  :min="filterStartDate || historyMinDate"
                  :max="historyMaxDate"
                  style="min-width: 130px"
                />
              </div>
            </div>

            <div class="management-section mb-3">
              <history-chart
                :loading-data="loadingRecalcManagement"
                chart-height="400px"
                :management-history-data="filteredManagementHistory"
                :sensor-history-data="sensorHistoryData"
                :sector-name="item.NAME"
              />
            </div>

            <div class="management-section mb-3">
              <div class="d-flex justify-content-between align-items-center mb-2" style="gap: 0.5rem">
                <div class="d-flex align-items-center flex-wrap" style="gap: 0.5rem">
                  <b-button
                    size="sm"
                    variant="secondary"
                    class="rounded-pill text-nowrap"
                    @click="downloadCSV"
                  >
                    <csv-icon style="font-size: 1.1em; vertical-align: -3%" />
                    Baixar CSV
                  </b-button>
                  <b-button
                    size="sm"
                    variant="secondary"
                    class="rounded-pill text-nowrap"
                    @click="downloadXLSX"
                  >
                    <excel-icon style="font-size: 1.1em; vertical-align: -3%" />
                    Baixar XLSX
                  </b-button>
                  <b-button
                    size="sm"
                    variant="secondary"
                    class="rounded-pill text-nowrap"
                    @click="downloadPDF"
                  >
                    <pdf-icon style="font-size: 1.1em; vertical-align: -3%" />
                    Baixar PDF
                  </b-button>
                </div>

                <div class="flex-shrink-0 ml-2 d-flex" style="gap: 0.5rem">
                  <b-button
                    size="sm"
                    variant="outline-secondary"
                    class="text-nowrap"
                    :disabled="!historyItemsToBeUpdated || !historyItemsToBeUpdated.length"
                    @click="undoManagementChanges"
                  >
                    Desfazer alterações
                  </b-button>
                  <b-button
                    size="sm"
                    :variant="
                      historyItemsToBeUpdated && historyItemsToBeUpdated.length
                        ? 'success'
                        : 'secondary'
                    "
                    :disabled="!historyItemsToBeUpdated || !historyItemsToBeUpdated.length"
                    @click="recalcManagementHandler"
                  >
                    Salvar dados e recalcular manejo
                  </b-button>
                </div>
              </div>

              <data-table
                ref="dataTable"
                editable
                sticky-header
                max-height-table="400px"
                :left-frozen-columns="leftFrozenColumns"
                :static-columns="staticColumns"
                :table-data="filteredManagementHistory"
                :initial-sort="[{ column: 'TIME', dir: 'desc' }]"
                :file-prefix="`Manejo ${item.NAME}`"
                @update-table-data="
                  (val) => (historyItemsBeforeUpdate = val)
                "
              />
            </div>

            <div class="management-section mb-3">
              <div class="mb-2">
                <b-button
                  v-if="editingSectorNote"
                  variant=""
                  @click="cancelEditSectorNote"
                  size="sm"
                >
                  Cancelar
                </b-button>

                <b-button
                  variant="3v3"
                  @click="editSectorNote"
                  size="sm"
                >
                  {{ editingSectorNote ? "Salvar" : "Editar" }}
                </b-button>
              </div>

              <p
                v-if="!editingSectorNote && item.NOTE"
                class="jump-line mb-0"
              >
                {{ item.NOTE }}
              </p>

              <div
                v-else-if="!editingSectorNote && !item.NOTE"
                class="font-italic"
              >
                Não foram adicionadas observações a este setor
              </div>

              <div v-else>
                <b-form-textarea
                  id="textarea"
                  v-model="item.NOTE"
                  placeholder="Observações..."
                  maxlength="65553"
                  rows="5"
                  size="sm"
                />
              </div>
            </div>
          </div>

          <div
            v-else
            class="w-100 d-flex justify-content-center font-weight-bold p-3 p-lg-5"
          >
            Não existem dados a serem mostrados por agora
          </div>
        </div>
      </div>
      <footer id="footer">
        <b-btn
          size="sm"
          block
          @click="$emit('close-details')"
          :class="`close-button ${bgStatus}`"
        >
          Fechar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { GetsSectorSensorsName } from "@/api/modules/sector/useCases/getsSectorSensorsNameUseCase.js";
import { UpdateSectorNote } from "@/api/modules/sector/useCases/updateSectorNoteUseCase.js";
import { GetSensorReportHistoryGraphic } from "@/api/modules/sector/useCases/getSensorReportHistoryGraphicUseCase.js";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import { management } from "@/api";
import { calcPercentageRounded } from "@/pages/components/helpers";
import DataTable from "@/pages/components/shared/table/DataTable.vue";
import table from "@/mixins/table";
import moment from "moment";
import { cmd } from "@/api";
import calcManagement from "@/mixins/calcManagement";
import { getManagementByIdSector } from "@/api/modules/management/useCase/getManagementBySector";
import HistoryChart from "./HistoryChart.vue";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  mixins: [table, calcManagement, managementSectorsActions],
  name: "sector-details",
  components: {
    DataTable,
    HistoryChart,
  },
  props: {
    isMobile: Boolean,
    item: Object,
    bgStatus: String,
    updated: String,
    editor: String,
    ending: String,
    showDetails: Boolean,
  },
  data() {
    return {
      baseHistoryItems: [],
      defaultBaseHistoryItems: [
        {
          RANGE_DAYS: 1,
          IRRIGATED_BLADE: 0,
          VOLUME: 0,
          RAINFALL: 0,
        },
        {
          RANGE_DAYS: 7,
          IRRIGATED_BLADE: 0,
          VOLUME: 0,
          RAINFALL: 0,
        },
        {
          RANGE_DAYS: 30,
          IRRIGATED_BLADE: 0,
          VOLUME: 0,
          RAINFALL: 0,
        },
      ],
      scheduleDetails: [],
      sensorHistoryData: [],
      editingSectorNote: false,
      itemNoteBeforeEdit: "",
      loadingRecalcManagement: false,
      historyItemsBeforeUpdate: [],
      sectorInfos: {},
      managementHistory: [],
      filterStartDate: '',
      filterEndDate: '',
      loadingDetails: true,
      currentLoadingMessage: "",
      leftFrozenColumns: [
        {
          title: "DIA",
          field: "TIME",
          minWidth: 120,
          maxWidth: 120,
          headerSort: true,
          headerSortStartingDir: "desc",
          sorter: "string",
          formatter: (cell) => moment(cell.getValue()).format("DD/MM/YYYY"),
          accessorDownload: (val) => moment(val).format("DD/MM/YYYY"),
        },
      ],
      staticColumns: [
        {
          title: "NDC",
          field: "NDC",
          minWidth: 90,
          width: 90,
          accessorDownload: (val) => val,
          editable: false,
        },
        {
          title: "DAP",
          field: "ID_DAP",
          minWidth: 90,
          width: 90,
          accessorDownload: (val) => val,
          editable: false,
        },
        {
          title: "KC",
          field: "KC",
          minWidth: 90,
          width: 90,
          accessorDownload: (val) => val,
          editable: false,
        },
        {
          title: "ET0 (mm)",
          field: "ET0",
          minWidth: 90,
          maxWidth: 90,
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Precipitação (mm)",
          field: "RAINFALL",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Precipitação Alegada (mm)",
          field: "RAINFALL_INPUT",
          editorParams: {
            allowEmpty: true,
          },
          mutatorEdit: function (value, data, type) {
            return value == "" ? null : value;
          },
          formatter: (cell) => {
            // const rainfallFieldVal = cell.getData().RAINFALL;
            const rainfallInputFieldVal = cell.getValue();
            const fieldVal =
              rainfallInputFieldVal !== null ? rainfallInputFieldVal : "-";
            const isMoreThanRainfallField = typeof fieldVal === "number";

            return `
              <span
                class="${isMoreThanRainfallField ? "font-weight-bold" : ""}"
                style="${isMoreThanRainfallField ? "color:#981b1b" : ""}"
              >
                ${fieldVal}
              </span>
            `;
          },
          validator: (cell, value) => {
            return value === "-" || value >= 0;
          },
          accessorDownload: (val, row) => {
            return this.decimalFormatter(val != null ? val : "-");
          },
        },
        {
          title: "Volume (m³)",
          field: "VOLUME",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Volume Alegado (m³)",
          field: "VOLUME_INPUT",
          formatter: (cell) => {
            const volumeFieldVal = cell.getData().VOLUME;
            const volumeInputFieldVal = cell.getValue();

            const fieldVal =
              volumeInputFieldVal != "" &&
              volumeInputFieldVal != null &&
              volumeInputFieldVal != volumeFieldVal
                ? volumeInputFieldVal
                : "-";
            const isMoreThanVolumeField = typeof fieldVal === "number";

            return `
              <span
                class="${isMoreThanVolumeField ? "font-weight-bold" : ""}"
                style="${isMoreThanVolumeField ? "color:#981b1b" : ""}"
              >
                ${fieldVal}
              </span>
            `;
          },
          validator: (cell, value) => {
            return (
              value === "" || value === "-" || value >= cell.getData().VOLUME
            );
          },
          accessorDownload: (val, row) => {
            const volumeFieldVal = row.VOLUME;
            return this.decimalFormatter(val != volumeFieldVal ? val : "-");
          },
        },
        {
          title: "Lâmina Aplicada (mm)",
          field: "IRRIGATED_BLADE",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Lâmina Sugerida (mm)",
          field: "BLADE_SUGGESTION",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
        {
          title: "Armazenamento Inicial (mm)",
          field: "INITIAL_STORAGE",
          visible: false,
          download: true,
          accessorDownload: (val) => this.decimalFormatter(val),
          editable: false,
        },
        {
          title: "Armazenamento Final (mm)",
          field: "FINAL_STORAGE",
          accessorDownload: (val) => this.decimalFormatter(val),
          editable: false,
        },
        {
          title: "Armazenamento Máximo (mm)",
          field: "MAX_STORAGE",
          accessorDownload: (val) => this.decimalFormatter(val),
          editable: false,
        },
        {
          title: "Disponibilidade de Água (%)",
          field: "WATER_DISPONIBILITY",
          minWidth: 160,
          width: 160,
          tooltip: (cell) => {
            return (
              `Água disponível: ${this.calcPercentageRounded(
                cell.getData().FINAL_STORAGE,
                cell.getData().MAX_STORAGE
              )}% (${cell.getData().FINAL_STORAGE}mm)` +
              `\npara armazenamento máximo de: ${cell.getData().MAX_STORAGE}mm`
            );
          },
          formatter: (cell) => {
            const currentSector = this.item;

            const storagePercentage = this.calcPercentageRounded(
              cell.getData().FINAL_STORAGE,
              cell.getData().MAX_STORAGE
            );

            const availability =
              (1 - currentSector.MANAGEMENT.AVAILABILITY) * 100;

            let bgColor = "bg-";

            if (storagePercentage <= availability) {
              bgColor += "danger";
            } else if (
              storagePercentage <=
              (100 - availability) / 2 + availability
            ) {
              bgColor += "warning";
            } else {
              bgColor += "3v3";
            }

            return `
              <div
                data-max="100"
                data-min="0"
                class="${bgColor}"
                style="display: inline-block;
                position: relative;
                width: ${storagePercentage}%;
                height: 100%;" >
              </div>`;
          },
          accessorDownload: (val, rowData) => {
            return this.calcPercentageRounded(
              rowData.FINAL_STORAGE,
              rowData.MAX_STORAGE
            );
          },
          hozAlign: "start",
          editable: false,
        },
        {
          title: "Excedente (mm)",
          field: "EXCESS",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
          editable: false,
        },
      ],
      active: "info",
      visible: false,
    };
  },
  mounted() {
    window.onclick = (event) => {
      if (
        event.target.id != "collapse-downloads" &&
        event.target.id != "downloads-options" &&
        this.showDownloadOptions
      ) {
        this.showDownloadOptions = false;
      }
    };
  },
  watch: {
    loadingRecalcManagement: {
      handler(newValue) {
        if (newValue) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
        }
      },
    },
    managementHistory: {
      deep: true,
      handler(newValue, oldValue) {
        const isFirstTimeRendering =
          oldValue && newValue && !oldValue.length && newValue.length;

        if (isFirstTimeRendering) {
          this.historyItemsBeforeUpdate = JSON.parse(JSON.stringify(newValue));
        }
      },
    },
    showDetails(newValue, oldValue) {
      if (!newValue && oldValue) this.active = "info";
    },
    active: {
      deep: true,
      immediate: true,
      async handler(newValue, oldValue) {
        this.baseHistoryItems = this.defaultBaseHistoryItems;
        this.showDetailsActuators(newValue);
        if (newValue == "charts" && this.item.MANAGEMENT) {
          this.loadingDetails = true;
          await this.getManagementHistoryData();
        }
      },
    },
    item: {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          this.editingSectorNote = false;
          this.itemNoteBeforeEdit = newValue.NOTE;
          await this.setSectorDetailsHistoryBase();
          await this.getSectorInfos();
          this.managementHistory = [];
        }

        if (
          Object.keys(newValue).length &&
          oldValue &&
          newValue.ID != oldValue.ID
        ) {
          this.active = "info";
        }
      },
    },
    isMobile() {
      this.showDetailsActuators(this.active);
    },
  },
  methods: {
    moment,
    async setSectorDetailsHistoryBase() {
      try {
        const rangeDaysList = this.defaultBaseHistoryItems.map(
          (historyItem) => historyItem.RANGE_DAYS
        );

        const baseHistoryData = await management.getDetailsBaseHistory({
          idSector: this.item.ID_SECTOR,
          rangeDaysList,
        });

        this.baseHistoryItems = baseHistoryData.map((rangeDay) => {
          rangeDay.RAINFALL = rangeDay.RAINFALL
            ? rangeDay.RAINFALL.toFixed(2)
            : 0;
          rangeDay.VOLUME = rangeDay.VOLUME ? rangeDay.VOLUME.toFixed(2) : 0;
          rangeDay.IRRIGATED_BLADE = rangeDay.IRRIGATED_BLADE
            ? rangeDay.IRRIGATED_BLADE.toFixed(2)
            : 0;

          return rangeDay;
        });
      } catch (e) {
        this.baseHistoryItems = this.defaultBaseHistoryItems;

        console.error(
          "Ocorreu um erro ao solicitar o historico base do setor",
          e
        );
        alert("Ocorreu um erro ao solicitar o historico base do setor", "e");
      }
    },
    bladeTableClass(item, type) {
      if (!item || type !== "row") return;
      if (this.item.MANAGEMENT.STRESS && item.is_suggestion_blade) {
        return "bg-red text-white";
      }
    },
    bladeToMinutes(blade) {
      const hasAverage = !!this.item.FLOW_AVG;
      let blade_suggestion_minutes = 0;

      if (hasAverage) {
        blade_suggestion_minutes =
          (this.bladeToVol(blade) / this.item.FLOW_AVG) * 60;
      } else {
        blade_suggestion_minutes =
          (blade * 60) / this.transmissivity / this.item.APPLICATION_RATE;
      }

      return Math.round(blade_suggestion_minutes);
    },
    bladeToVol(blade) {
      return this.lam2vol(blade, Number(this.item.AREA), this.transmissivity);
    },
    async getManagementHistoryData() {
      await getManagementByIdSector()
        .execute(this.item.ID_SECTOR)
        .then((history) => {
          // history pode vir [] (ex.: /sql negado por userPermission != 1). Não quebrar o .map
          // nem, adiante, o acesso a history[0].TIME — o reload é resiliente ao caso vazio.
          const historyCalculated = (history || []).map((row) => {
            row.NDC = this.calcNDC(
              this.item.PLANTING_DATE,
              row.TIME,
              this.item.OFFSET_DAP
            );

            return row;
          });

          this.managementHistory = historyCalculated;

          this.historyItemsBeforeUpdate = JSON.parse(
            JSON.stringify(this.managementHistory)
          );

          return historyCalculated;
        })
        .then(async (history) => {
          // Sem histórico (ex.: reload retornou vazio) não há intervalo para os sensores.
          if (!history || !history.length) {
            this.sensorHistoryData = [];
            return;
          }
          const sectorSensorsName = await new GetsSectorSensorsName().execute(
            this.item.ID_SECTOR
          );
          const sensorsHistorys = [];

          for (const sensor of sectorSensorsName) {
            const sensorHistoryAvg =
              await new GetSensorReportHistoryGraphic().execute(
                sensor.SENSOR_NAME,
                {
                  start: history[0].TIME,
                  end: history[history.length - 1].TIME,
                }
              );

            if (sensorHistoryAvg && sensorHistoryAvg.length) {
              // Filling up days with no occurencies with 0

              const sensorDaysMapped = history.map((managementDay) => {
                const daySensorRead = sensorHistoryAvg.find(
                  (day) =>
                    moment(day.TIME).format("YYYY-MM-DD") ==
                    moment(managementDay.TIME).format("YYYY-MM-DD")
                );

                return {
                  VALUE: daySensorRead ? daySensorRead.VALUE : 0,
                  TIME: managementDay.TIME,
                  SENSOR_NAME: sensorHistoryAvg[0].SENSOR_NAME,
                };
              });

              sensorsHistorys.push(sensorDaysMapped);
            }
          }

          this.sensorHistoryData = sensorsHistorys;
        })
        .finally(() => (this.loadingDetails = false));
    },
    cancelEditSectorNote() {
      this.editingSectorNote = false;
      this.item.NOTE = this.itemNoteBeforeEdit;
    },
    async editSectorNote() {
      if (this.editingSectorNote) {
        return await new UpdateSectorNote()
          .execute(this.item.ID_SECTOR, this.item.NOTE)
          .then((r) => {
            this.editingSectorNote = false;
            this.itemNoteBeforeEdit = this.item.NOTE;
            return alert("Sucesso ao salvar nova observação do setor", "s");
          })
          .catch((err) => {
            return alert("Erro ao salvar nova observação do setor", "e");
          });
      }

      this.editingSectorNote = true;
    },
    async recalcManagementHandler() {
      if (
        !this.historyItemsToBeUpdated ||
        !this.historyItemsToBeUpdated.length
      ) {
        return;
      }

      this.loadingRecalcManagement = true;
      this.currentLoadingMessage = "Salvando e recalculando dados de manejo...";

      try {
        const sectorId = Number(this.item.ID_SECTOR);
        const rows = this.historyItemsToBeUpdated;

        // Recalcula só a partir da data editada mais antiga: o balanço encadeia FINAL_STORAGE
        // para frente, então dias anteriores não mudam. Sem isso, o backend reprocessava todo o
        // histórico do setor (centenas/milhares de dias) e o request travava em "load infinito".
        const fromDate = rows
          .map((r) => moment(r.TIME).format("YYYY-MM-DD"))
          .sort()[0];

        // Até a última data da tabela do setor, não "ontem" (default do backend).
        const toDate = this.historyMaxDate;

        // Uma requisição: backend persiste volume + precipitação e recalcula (atômico). Ver cron_management.md §7.
        await management.recalc({
          sectorIds: [sectorId],
          fromDate,
          toDate,
          volumeInputs: rows.map((r) => ({ sectorId, TIME: r.TIME, VALUE: r.VOLUME_INPUT })),
          rainfallInputs: rows.map((r) => ({ sectorId, TIME: r.TIME, VALUE: r.RAINFALL_INPUT })),
        });

        await this.getManagementHistoryData();
        return alert("Sucesso ao recalcular o manejo", "s");
      } catch (e) {
        console.error(e);
        return alert("Erro ao recalcular o manejo", "e");
      } finally {
        this.loadingRecalcManagement = false;
      }
    },
    undoManagementChanges() {
      // Restaura o histórico ao último estado carregado (snapshot em historyItemsBeforeUpdate),
      // descartando edições não salvas. O DataTable observa :table-data (filteredManagementHistory)
      // e chama replaceData sozinho, então basta reatribuir managementHistory.
      if (!this.historyItemsBeforeUpdate || !this.historyItemsBeforeUpdate.length) return;
      this.managementHistory = JSON.parse(JSON.stringify(this.historyItemsBeforeUpdate));
    },
    calcPercentageRounded,
    async getSectorInfos() {
      this.loadingDetails = true;

      let rawSectorDetails = `
        SELECT
          SUM(EXCESS) EXCESS_ACCUMULATED,
          SUM(VOLUME) VOLUME_ACCUMULATED
        FROM CROP.MANAGEMENT MANAGEMENT
        WHERE (
          ID_SECTOR = ${this.item.ID_SECTOR}
          AND DATE(NOW()) > DATE(MANAGEMENT.TIME)
        );
      `;

      let rawScheduleDetails = `
        SELECT
        AGN_INFOS.NAME,
        SUM(AGN_INFOS.DURATION) DURATION
      FROM (
        SELECT
          AGN_TIME.NAME,
          AGN_DURATION.TIME DURATION
        FROM NEWSIR.AGN_VALVE AGN_VALVE
        JOIN NEWSIR.AGN_TIME AGN_TIME
        ON AGN_VALVE.FK_AGN = AGN_TIME.ID
        JOIN NEWSIR.AGN_DURATION AGN_DURATION
        ON AGN_DURATION.ID = AGN_VALVE.FK_DURATION
        WHERE (
          AGN_VALVE.FK_VALVE = ${this.item.ID_VALVE}
          AND DATE(AGN_TIME.START_DATE) <= DATE(NOW())
            AND IF(ISNULL(AGN_TIME.END_DATE), TRUE, DATE(AGN_TIME.END_DATE) >= DATE(NOW()))
            AND (AGN_TIME.ACTIVITY_DAYS & POWER(2, (DAYOFWEEK(NOW()) - 1 ))) =  POWER(2, (DAYOFWEEK(NOW()) - 1 ))
        )
      ) AGN_INFOS
      GROUP BY AGN_INFOS.NAME
      `;

      const sectorInfos = await new Promise((resolve, reject) => {
        management
          .sql({
            data: {
              sql: rawSectorDetails,
            },
          })
          .then((ret) => {
            if (ret[0] && ret[0][0] && ret[0][0]) {
              resolve(ret[0][0]);
            } else {
              resolve({});
            }
          })
          .catch((err) => {
            console.log(err);
            reject({});
          });
      });

      this.sectorInfos = sectorInfos;

      const scheduleDetails = await new Promise((resolve, reject) => {
        management
          .sql({
            data: {
              sql: rawScheduleDetails,
            },
          })
          .then((ret) => {
            if (ret[0] && ret[0][0] && ret[0][0]) {
              resolve(ret[0]);
            } else {
              resolve([]);
            }
          })
          .catch((err) => {
            console.log(err);
            reject([]);
          });
      });

      this.scheduleDetails = scheduleDetails;

      this.loadingDetails = false;
    },
    downloadCSV() {
      return this.$refs.dataTable ? this.$refs.dataTable.downloadCSV() : "";
    },
    downloadXLSX() {
      return this.$refs.dataTable ? this.$refs.dataTable.downloadXLSX() : "";
    },
    downloadPDF() {
      const data = this.$refs.dataTable?.tabulator?.getData() ?? [...this.filteredManagementHistory].reverse();
      if (!data.length) return;

      const fmt = (val) => (typeof val === 'number' ? val.toFixed(2) : (val ?? '-'));

      let hasUserData = false;
      const rows = data.map(row => {
        const rainfallUserSupplied = row.RAINFALL_INPUT !== null && row.RAINFALL_INPUT !== undefined;
        const volumeUserSupplied = row.VOLUME_INPUT !== null && row.VOLUME_INPUT !== undefined
          && row.VOLUME_INPUT !== '' && row.VOLUME_INPUT !== row.VOLUME;

        if (rainfallUserSupplied || volumeUserSupplied) hasUserData = true;

        const rainfallVal = rainfallUserSupplied ? `${fmt(row.RAINFALL_INPUT)} *` : fmt(row.RAINFALL);
        const volumeVal = volumeUserSupplied ? `${fmt(row.VOLUME_INPUT)} *` : fmt(row.VOLUME);

        return [
          moment(row.TIME).format('DD/MM/YYYY'),
          fmt(row.NDC),
          fmt(row.ID_DAP),
          fmt(row.KC),
          fmt(row.ET0),
          rainfallVal,
          volumeVal,
          fmt(row.IRRIGATED_BLADE),
          fmt(row.BLADE_SUGGESTION),
          fmt(row.INITIAL_STORAGE),
          fmt(row.FINAL_STORAGE),
          fmt(row.MAX_STORAGE),
          `${this.calcPercentageRounded(row.FINAL_STORAGE, row.MAX_STORAGE)}%`,
          fmt(row.EXCESS),
        ].map(v => ({ text: String(v), style: 'tableData' }));
      });

      const headerStyle = { style: 'tableHeader', fillColor: '#7bb34b', color: '#fff' };
      const headers = [
        'DIA', 'NDC', 'DAP', 'KC', 'ET0 (mm)',
        'Precipitação (mm)', 'Volume (m³)',
        'Lâm. Aplic. (mm)', 'Lâm. Suger. (mm)',
        'Arm. Inicial (mm)', 'Arm. Final (mm)', 'Arm. Máx. (mm)',
        'Água Disp. (%)', 'Excedente (mm)',
      ].map(h => ({ text: h, ...headerStyle }));

      const content = [
        { text: `Manejo - ${this.item.NAME}`, style: 'title' },
        { text: moment().format('DD/MM/YYYY'), style: 'date', alignment: 'right' },
        {
          table: {
            headerRows: 1,
            widths: Array(headers.length).fill('auto'),
            body: [headers, ...rows],
          },
          layout: {
            fillColor: (rowIndex) => rowIndex > 0 && rowIndex % 2 === 0 ? '#f0f4f4' : null,
          },
        },
      ];

      if (hasUserData) {
        content.push({ text: '* - Dados inseridos pelo usuário', style: 'footnote', margin: [0, 6, 0, 0] });
      }

      pdfMake.createPdf({
        pageOrientation: 'landscape',
        pageSize: 'A4',
        pageMargins: [20, 30, 20, 30],
        content,
        styles: {
          title: { fontSize: 12, bold: true, margin: [0, 0, 0, 4] },
          date: { fontSize: 9, margin: [0, 0, 0, 8] },
          tableHeader: { fontSize: 8, bold: true, alignment: 'center' },
          tableData: { fontSize: 8, alignment: 'center' },
          footnote: { fontSize: 8, italics: true, color: '#555' },
        },
      }).download(`Manejo ${this.item.NAME} ${moment().format('YYYY-MM-DD')}.pdf`);
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    showDetailsActuators(active) {
      let details = document.getElementById("details");
      let header = document.getElementById("header");
      let footer = document.getElementById("footer");
      if (active == "info") {
        let width = this.isMobile ? "100%" : "361px";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      } else if (active == "charts") {
        let width = this.isMobile ? "100%" : "calc(100% - 51px)";
        details ? (details.style.width = width) : "";
        header ? (header.style.width = width) : "";
        footer ? (footer.style.width = width) : "";
      }
    },
    selectDetails(idx) {
      let tabs = ["info", "charts"];
      this.active = tabs[idx];
    },
    sendButton(i, btn) {
      let newCMD = btn.CMD.concat(" ", this.$refs.input[i].$el.value);
      this.buttons(newCMD);
    },
    buttons(command) {
      let SET = true;
      let CMD = command;
      let data = { SET, CMD };
      this.changeProp(data, "reqofw");
    },
    // O firmware não escreve resposta em /mnt/fcir/rsp/ pra nenhum comando
    // disparado pelos BUTTONS do JSON de status (Atualizar → SDI12_CMD,
    // MB_REFRESH, SNS_REFRESH: nenhum desses handlers chama set_rsp() no
    // firmware) — só o resultado do próprio reqofw (arquivo de comando
    // gravado ou não) é significativo aqui.
    changeProp(data, apiFunction) {
      data.ITEM = this.item.ID;
      wait.show();
      cmd[apiFunction](data)
        .then((ret) => {
          wait.hide();
          if (!ret.status) alert(ret.log, ret.alert);
        })
        .catch((err) => {
          console.log(err);
          wait.hide();
        });
    },
  },
  computed: {
    historyMinDate() {
      if (!this.managementHistory.length) return null;
      return this.managementHistory[0].TIME.slice(0, 10);
    },
    historyMaxDate() {
      if (!this.managementHistory.length) return null;
      return this.managementHistory[this.managementHistory.length - 1].TIME.slice(0, 10);
    },
    filteredManagementHistory() {
      let data = this.managementHistory;
      if (this.filterStartDate) {
        data = data.filter(row => row.TIME.slice(0, 10) >= this.filterStartDate);
      }
      if (this.filterEndDate) {
        data = data.filter(row => row.TIME.slice(0, 10) <= this.filterEndDate);
      }
      return data;
    },
    transmissivity() {
      return this.item.SYSTEM_EFFICIENCY * this.item.SOIL.TRANSMISSIVITY;
    },
    managementDate() {
      return moment(this.item.MANAGEMENT.TIME).format("DD/MM/YYYY");
    },
    scheduleItems() {
      const currentAgnVolumePreview =
        this.item &&
        this.item.SCHEDULE &&
        this.item.SCHEDULE.SCHEDULE_VOLUME_PREVIEW &&
        this.item.SCHEDULE.SCHEDULE_VOLUME_PREVIEW.toFixed(2);
      const bladeSuggestionBase = Math.abs(
        this.item.MANAGEMENT.ETR_PREDICTION.toFixed(2)
      );
      let negativeAcc = Number(
        (this.item.MANAGEMENT.BLADE_SUGGESTION - bladeSuggestionBase).toFixed(2)
      );
      negativeAcc > 0 ? negativeAcc : 0;

      const isStressDay = !!this.item.MANAGEMENT.STRESS;

      return [
        {
          agn_name: "Atual",
          blade: this.item.MANAGEMENT.IRRIGATED_BLADE,
          volume:
            currentAgnVolumePreview > 0
              ? currentAgnVolumePreview
              : this.bladeToVol(this.item.MANAGEMENT.IRRIGATED_BLADE),
          duration:
            (this.item.SCHEDULE && this.item.SCHEDULE.SCHEDULE_DURATION) || 0,
        },
        {
          is_suggestion_blade: true,
          agn_name: `Sugerida${isStressDay ? "\n(Estresse)" : ""}`,
          blade:
            this.item.MANAGEMENT.BLADE_SUGGESTION && !isStressDay
              ? this.item.MANAGEMENT.BLADE_SUGGESTION
              : 0,
          volume:
            this.item.MANAGEMENT.BLADE_SUGGESTION && !isStressDay
              ? this.bladeToVol(this.item.MANAGEMENT.BLADE_SUGGESTION)
              : 0,
          duration:
            this.item.MANAGEMENT.BLADE_SUGGESTION && !isStressDay
              ? this.bladeToMinutes(this.item.MANAGEMENT.BLADE_SUGGESTION)
              : 0,
        },
      ];
    },
    suggestionScheduleInfo() {
      const bladeSuggestionBase =
        this.item.MANAGEMENT.ID_DAP <= 1
          ? this.item.MANAGEMENT.BLADE_SUGGESTION
          : Math.abs(this.item.MANAGEMENT.ETR_PREDICTION.toFixed(2));
      let negativeAcc = Number(
        (this.item.MANAGEMENT.BLADE_SUGGESTION - bladeSuggestionBase).toFixed(2)
      );
      negativeAcc > 0 ? negativeAcc : 0;

      return [
        {
          agn_name: "Pendente",
          blade: negativeAcc,
          volume: negativeAcc ? this.bladeToVol(negativeAcc) : 0,
          duration: negativeAcc ? this.bladeToMinutes(negativeAcc) : 0,
        },
        {
          agn_name: "Hoje",
          blade: bladeSuggestionBase,
          volume: this.bladeToVol(bladeSuggestionBase),
          duration: bladeSuggestionBase
            ? this.bladeToMinutes(bladeSuggestionBase)
            : 0,
        },
      ];
    },
    runningSchedulesInfo() {
      const bladeSuggestionBase = Math.abs(
        this.item.MANAGEMENT.ETR_PREDICTION.toFixed(2)
      );
      let negativeAcc = Number(
        (this.item.MANAGEMENT.BLADE_SUGGESTION - bladeSuggestionBase).toFixed(2)
      );
      negativeAcc > 0 ? negativeAcc : 0;

      return this.scheduleDetails.length && this.scheduleItems.length
        ? this.scheduleDetails.map((level) => {
            const currentSchedule = this.scheduleItems[0];
            const percentage =
              level.DURATION / this.item.SCHEDULE.SCHEDULE_DURATION;

            return {
              agn_name: level.NAME,
              blade: (percentage * currentSchedule.blade).toFixed(2) || "-",
              volume: (percentage * currentSchedule.volume).toFixed(2) || "-",
              duration: level.DURATION,
            };
          })
        : [];
    },
    scheduleFields() {
      return [
        { key: "agn_name", label: "Agenda", class: "text-aln-center" },
        { key: "duration", label: "Duração\n(min)", class: "text-aln-center" },
        {
          key: "blade",
          label: "Lâmina líquida\n(mm)",
          class: "text-aln-center",
        },
        {
          key: "volume",
          label: "Volume Previsto\n(m³)",
          class: "text-aln-center",
        },
      ];
    },
    baseHistoryFields() {
      return [
        {
          key: "RANGE_DAYS",
          label: "Dias em análise",
          class: "text-aln-center",
        },
        {
          key: "RAINFALL",
          label: "Pluviometria\n(mm)",
          class: "text-aln-center",
        },
        {
          key: "IRRIGATED_BLADE",
          label: "Lâmina líquida\n(mm)",
          class: "text-aln-center",
        },
        { key: "VOLUME", label: "Volume\n(m³)", class: "text-aln-center" },
      ];
    },
    historyItemsToBeUpdated() {
      if (
        !this.historyItemsBeforeUpdate ||
        !this.historyItemsBeforeUpdate.length
      ) {
        return [];
      }
      // Normaliza vazio/"-"/null → "sem override" (null); senão número. Sem isso, só focar e
      // sair de uma célula (que o editor devolve como string) marcava a linha como alterada por
      // diferença de TIPO ("5" !== 5), habilitando o Salvar sem mudança real. Computed PURO (não
      // muta managementHistory) para não dessincronizar do snapshot historyItemsBeforeUpdate.
      const norm = (v) =>
        v === "" || v === "-" || v === null || v === undefined
          ? null
          : Number(v);

      return this.managementHistory.filter((row, index) => {
        const before = this.historyItemsBeforeUpdate[index];
        if (!before) return false;
        const volChanged =
          norm(row.VOLUME_INPUT) !== norm(before.VOLUME_INPUT);
        const rainChanged =
          norm(row.RAINFALL_INPUT) !== norm(before.RAINFALL_INPUT);
        return volChanged || rainChanged;
      });
    },
    blade_suggestion_minutes() {
      const hasAverage = !!this.item.FLOW_AVG;
      let blade_suggestion_minutes = 0;

      if (hasAverage) {
        blade_suggestion_minutes =
          (this.vol_from_blade_suggestion / this.item.FLOW_AVG) * 60;
      } else {
        blade_suggestion_minutes =
          (this.item.MANAGEMENT.BLADE_SUGGESTION * 60) /
          this.transmissivity /
          this.item.APPLICATION_RATE;
      }

      return Math.round(blade_suggestion_minutes);
    },
    vol_from_blade_suggestion() {
      return this.lam2vol(
        this.item.MANAGEMENT.BLADE_SUGGESTION,
        Number(this.item.AREA),
        this.transmissivity
      );
    },
    getBladeSuggestion() {
      let today = moment().format("YYYY-MM-DD");
      if (this.item.PLANTING_DATE === today) {
        return this.item.FARM.LAMINA;
      }
      return this.item.MANAGEMENT && this.item.MANAGEMENT.BLADE_SUGGESTION
        ? this.item.MANAGEMENT.BLADE_SUGGESTION
        : 0;
    },
  },
};
</script>

<style scoped>
.table-agn >>> .text-aln-center {
  text-align: center !important;
  vertical-align: middle !important;
}

.jump-line {
  white-space: pre-line;
}

.download-options {
  position: absolute;
  background: white;
  padding: 5px;
  right: 0;
  margin: 0 10px;
  z-index: 99;
  min-width: 10em;
  max-width: 15em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.1s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 4px;
}
.ad-percentage-title {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  margin-top: 2px;
  color: var(--text-gray-primary);
  font-size: 1em;
}
.close-button {
  border: none;
  width: 100%;
  border-radius: 4px;
  color: #ffff;
  outline: none;
}
.close-button:hover {
  filter: contrast(80%);
}
.buttons {
  margin-top: 5px;
}
.container-command div + div {
  margin-top: 6px;
}
.warning-command {
  font-size: 0.8em;
  color: #616161;
  margin-bottom: 0px;
  padding: 8px;
  background-color: #f5f7a593;
  border-radius: 4px;
}
.warning-command .material-design-icon {
  font-size: 0.9em !important;
}
.container-command .cmd-button {
  margin-right: 0px;
}
.label {
  padding: 0;
  font-size: 0.8em;
  /* margin: 0; */
}
.status {
  background: #d0ddcca6;
  border-radius: 4px;
}
.obs-info {
  text-align: center;
  font-size: 0.68em;
}
.percent-box {
  background-color: #8a8a8a;
  border-radius: 10px;
}
.percent-progress {
  border-radius: 10px;
  height: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.percent-text,
.percent-value {
  z-index: 2;
}
@keyframes bar-animation {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 80px 80px;
  }
}
.monit-tabs {
  transition: all 0.5s ease;
}
.dir-id {
  font-size: 0.85em;
}
.percent-ping {
  right: 8px;
  z-index: 33;
}
.ios .btn {
  margin: 5px 0;
}
.ios .max-table-height {
  max-height: 300px;
  overflow: auto;
}

.management-section {
  border-top: 1px solid #dee2e6;
  padding-top: 0.75rem;
}

.section-label {
  font-weight: 600;
  font-size: 0.875rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.management-section >>> td,
.management-section >>> th {
  padding: 0.5rem !important;
}

.filter-section-box {
  background-color: #f1f3f5;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
}

.filter-section-label {
  font-size: 1rem;
  font-weight: 600;
  color: #495057;
}
</style>
